import React from "react";
import * as ReactDOM from "react-dom/client"; // ✅ use client API
import ConfirmModal from "./ConfirmModal";

function confirm(config) {
    const div = document.createElement("div");
    document.body.appendChild(div);

    // ✅ createRoot once for this instance
    const root = ReactDOM.createRoot(div);

    function destroy(...args) {
        // Schedule unmount asynchronously
        setTimeout(() => {
            root.unmount();

            if (div.parentNode) {
                div.parentNode.removeChild(div);
            }

            const triggerCancel = args.some(
                (param) => param && param.triggerCancel
            );

            if (config.onCancel && triggerCancel) {
                config.onCancel(...args);
            }
        });
    }

    let currentConfig = { ...config, close, visible: true };

    function render({ okText, cancelText, ...props }) {
        // Keep async render to avoid sync blocking
        setTimeout(() => {
            root.render(
                <ConfirmModal
                    {...props}
                    okText={okText}
                    cancelText={cancelText}
                />
            );
        }, 10);
    }

    function close(...args) {
        currentConfig = {
            ...currentConfig,
            visible: false,
            afterClose: destroy.bind(this, ...args),
        };
        render(currentConfig);
    }

    function update(newConfig) {
        currentConfig = {
            ...currentConfig,
            ...newConfig,
        };
        render(currentConfig);
    }

    render(currentConfig);

    return {
        destroy: close,
        update,
    };
}

export default confirm;
